import { styled } from 'styled-components'
import { Drawer as MuiDrawer, Dialog as MuiDialog } from '@mui/material'
import Button from 'mixtiles-web-common/ui/Button'
import { onLargeScreen } from 'mixtiles-web-common'

export const Dialog = styled(MuiDialog)`
  &.MuiDialog-root {
    z-index: 1500 !important;
  }

  .MuiDialog-paper {
    border-radius: 12px;
    text-align: center;
    padding: 40px 50px;
  }
`

export const Drawer = styled(MuiDrawer)`
  &.MuiDrawer-root {
    z-index: 1500 !important;
  }

  .MuiDrawer-paper {
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    text-align: center;
    padding: 32px 0 24px;
  }
`

export const Title = styled.h2`
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  line-height: 130%;
  color: ${(props) => props.theme.colors.black};

  ${onLargeScreen()} {
    font-size: 26px;
    width: 220px;
  }
`

export const ApplyButton = styled(Button)`
  margin: 28px auto 0;
`

export const DiscardLinkButton = styled.button`
  cursor: pointer;
  margin-top: 20px;
  border: 0;
  background: none;
  font-size: 16px;
  line-height: 130%;
  color: ${(props) => props.theme.colors.black};
  text-decoration: underline;
`
